/* Vitals homepage 2026 — shared behaviour.
   Loaded once per page even though several sections request it. */
(function () {
  if (window.__h26) return;
  window.__h26 = true;

  /* --- scroll reveal --- */
  function reveal() {
    var els = document.querySelectorAll('.h26 .h26-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var delay = parseInt(el.getAttribute('data-h26-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  /* --- [data-h26-tabs] : buttons with data-h26-tab switch panes with data-h26-pane --- */
  function tabs() {
    document.querySelectorAll('[data-h26-tabs]').forEach(function (root) {
      root.addEventListener('click', function (ev) {
        var btn = ev.target.closest('[data-h26-tab]');
        if (!btn || !root.contains(btn)) return;
        var key = btn.getAttribute('data-h26-tab');
        root.querySelectorAll('[data-h26-tab]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-h26-pane]').forEach(function (p) {
          p.hidden = p.getAttribute('data-h26-pane') !== key;
        });
      });
    });
  }

  function init() { reveal(); tabs(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* sections injected by the theme editor after load */
  document.addEventListener('shopify:section:load', init);
})();
